
import {useState, createContext, useEffect} from 'react';
import './messages.css';
import '../../Dashboard/dashboard.css'
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import { changeDisable } from '../../../services/Cadastros/service';
import { getPermission, showMessageError } from '../../../classes/functions';
import Select from 'react-select';

export default function CadMessages(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);

  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  const [users, setUsers] = useState([]);
  const [profiles, setProfiles] = useState([]);

  const [usersPermissions, setUserPermissions] = useState([]);
  const [profilesPermissions, setProfilesPermissions] = useState([]);

  const [optionsUsers, setOptionsUsers] = useState([]);
  const [optionsProfiles, setOptionsProfiles] = useState([]);

  const customStyles = {
    container: (provided) => ({
        ...provided,
        width: '100%',
        height: '100%'
    })
  }

  async function getUsers(){
    await api
          .get('/api/users/getList')
          .then((response) => {
            setUserPermissions(response.data);
          })
          .catch((error) => {
            toast.error('Ops! Não foi possível carregar os usuários.');
          });
  }

  async function getProfiles(){
    await api
          .get('api/profiles/getList')
          .then((response) => {
            setProfilesPermissions(response.data);
          })
          .catch((error) => {
            toast.error('Ops! Não foi possível carregar os perfis.');
          });
  }
  
  useEffect(()=> {
    async function loadProfile(){
      if (id) { 
        getOne(id, option);
      } else {
        setCarrying(false);
      }
    }

    loadProfile();

  },[]);

  function validForm() {
    if ((title !== '' && message !== '' && users !== [])) {
      return true;
    } else {
      toast.error('Preencha todos os campos com * antes de salvar.');
      return false;
    }
  }

  function save(e){
    setCarrying(true);
    e.preventDefault();
     
    if (!validForm()) {
      setCarrying(false);
      return false;
    }

    const loginUser = localStorage.getItem('usuario');
    const loggedCompany = localStorage.getItem('empresa');
    
    let selectedUsers = [];
    let usersByProfile = [];
    let array = [];

    profiles.map((profile) => {
      optionsUsers.map((user) => {
        if(user.perfil === profile.label){
          usersByProfile.push(user);
        }
      })
    });

    usersByProfile.map((userByProfile) => {
      selectedUsers.push(userByProfile.id);
    });

    users.map((user) => {
      selectedUsers.push(user.id);
    });
    
    selectedUsers.map((selectedUser) => {
      if(!array.includes(selectedUser)){
        array.push(selectedUser);
      }
    })

    const data = {
        title: title,
        message: message,
        to: array,
        created_by: parseInt(loginUser),
        company: parseInt(loggedCompany)
    }

    if (id) { 
      data.id = id;
      api.put(`/api/messages/${id}`, data)
      .then((response) => {
          toast.success('Registro atualizado com sucesso.');
          history.push('/messages');
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    } else {
      api.post("/api/messages", data)
      .then((response) => {
          toast.success('Registro inserido com sucesso.');
          history.push('/messages');
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  async function getUser(id){
    await api
          .get(`/api/users/getList?id=${id}`)
          .then((response) => {
            setUsers({id: response.data.row.id, label: response.data.row.nome, value: response.data.row.nome});
          })
          .errro((error) => {
            console.log(error)
        })
  }

  function getOne(id, option){
    api.get("/api/messages?id=" + id)
    .then((response) => {
        response.data.result.map((result) => {
            setTitle(result.title);
            setMessage(result.message);
            getUser(result.to[0]);
        })
        setCarrying(false);
      }
    ).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
    
    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/messages');
  }

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    getProfiles();
  }, []);

  useEffect(() => {
    setOptionsUsers(usersPermissions.map((user) => {
        return {id: user.id, label: user.nome, value: user.nome, ...user}
    }));
  }, [usersPermissions]);

  useEffect(() => {
    setOptionsProfiles(profilesPermissions.map((user) => {
        return {id: user.id, label: user.nome, value: user.nome}
    }));
  }, [profilesPermissions]);

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
              
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Mensagens">
          <Link to="/messages">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>
            <div className="divGroup">
                <div className="formDiv">
                  <label>Título&nbsp;<label className="required">*</label></label><br/>
                  <input type="text" placeholder="Título" value={title} onChange={ (e) => setTitle(e.target.value) } disabled={view} maxLength="30" required="true"/>
                </div>
                <div className="formDiv">
                  <label>Mensagem&nbsp;<label className="required">*</label></label><br/>
                  <input type="text" placeholder="Mensagem" value={message} onChange={ (e) => setMessage(e.target.value) } disabled={view} maxLength="150" required="true"/>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', marginTop: '0.5rem', width: '100%', height: '30px'}}>
                  <label>Usuário&nbsp;<label className="required">*</label></label>
                  <Select placeholder="Usuário" className='select' styles={customStyles} isMulti options={optionsUsers} value={users} onChange={ (e) => setUsers(e) } disabled={view} maxLength="30" required="true"/>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', marginTop: '0.5rem', marginLeft: '0.6rem' , width: '100%', height: '30px'}}>
                  <label>Grupo&nbsp;<label className="required">*</label></label>
                  <Select placeholder="Grupo" className='select' styles={customStyles} isMulti options={optionsProfiles} value={profiles} onChange={ (e) => setProfiles(e) } disabled={view} maxLength="30" required="true"/>
                </div>
            </div>
            </div>
            {!view && <div className="formDiv">
              {getPermission('CADASTROS - MENSAGENS - CADASTRO') && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Enviar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
            </div>}
          </form>
        </div>
      </div>}
    </div>
  )
}